// Scope to prevent namespace collisions
import throttle from 'lodash/throttle';

(function() {
  let scrollToTopBtn = document.querySelector('[data-target="toTop"]');
  let rootElement = document.documentElement;
  let threshold = window.innerHeight / 2;


  if (document.body.getAttribute('data-type') === 'topic' && !scrollToTop) {
    console.error("Unable to find scroll to top button");
    return null;
  }

  // stop function if there isn't a scrollToTopBtn
  if (!scrollToTopBtn) {
    return null;
  }


  function showScrollToTop() {
    let scrollPosition = window.scrollY;

    if (scrollPosition > threshold) {
      scrollToTopBtn.classList.add('is-shown');
    } else {
      scrollToTopBtn.classList.remove('is-shown');
    }
  }

  function scrollToTop() {
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  document.addEventListener('scroll', throttle(showScrollToTop, 2500, { trailing: true }));

  // let observer = new IntersectionObserver((entries, observer) => {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       console.log(entry);
  //       scrollToTopBtn.classList.add('is-shown');
  //     } else {
  //       scrollToTopBtn.classList.remove('is-shown');
  //     }
  //   });
  // });



  // observer.observe(scrollToTopBtn);

  scrollToTopBtn.addEventListener('click', function(evt) {
    evt.preventDefault();

    scrollToTop();
  });
})();
